import { Customer, CustomerSmsSettingVo, CustomerVo } from "@supplier/entity";
import { CustomerForgotPasswordForm, CustomerRegistrationForm } from "@supplier/entity/src/entity/customer";
import { confirmable } from "@/utils/decorator/confirmable";
import { BaseService } from "@/api/services/baseService";
import { customerHttp } from "@/api";

export class SassCustomerService extends BaseService<Customer, CustomerVo, unknown, unknown> {
    /**
     * 注册账号
     */
    public async registerAccount(params: CustomerRegistrationForm): Promise<Customer> {
        const { data } = await this.service.post(`customer/registration`, params);
        return data;
    }

    /**
     * 忘记密码
     */
    public async forgotPassword(params: CustomerForgotPasswordForm): Promise<string> {
        const { data } = await this.service.put(`${this.path}/customer/password/forgot`, params);
        return data;
    }

    /**
     * 保存短信设置
     */
    @confirmable("是否保存")
    async getCustomerAndSubSave(customerSmsVos: CustomerSmsSettingVo[]): Promise<unknown> {
        const { data } = await this.service.post(`/customer/customer-sub`, { customerSmsVos });
        return data;
    }
}

export const customerService = new SassCustomerService("", customerHttp.service);
